// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import React from 'react';

export default () => (

    <svg
        width='41'
        height='41'
        viewBox='0 0 41 41'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M20.1337 2.5C9.05453 2.5 0 11.4255 0 22.4841C0 27.9853 2.24957 33.3182 6.2988 37.0792C7.70479 38.4265 9.89812 38.5387 11.4728 37.3599C16.5344 33.5988 23.508 33.5988 28.5696 37.3599C30.1443 38.5387 32.3376 38.4265 33.7436 37.0792C41.7858 29.4448 42.1232 16.7583 34.4747 8.731C30.7629 4.80154 25.5326 2.55614 20.1337 2.5ZM20.0212 32.5323C14.6222 32.7007 10.1231 28.4344 10.0106 23.1016C10.0106 22.9332 10.0106 22.7648 10.0106 22.5964C10.0106 17.0951 14.5097 12.6043 20.0212 12.6043C25.5326 12.6043 30.0318 17.0951 30.0318 22.5964C30.2005 27.9853 25.9263 32.42 20.5836 32.5884C20.3586 32.5323 20.1899 32.5323 20.0212 32.5323Z'
            fill='#62D84E'
        />
    </svg>
);
